import { useTheme } from "@emotion/react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { STORAGE_URL } from "../constants";
import { Logo } from "../staticData/images";
import CustomButton from "./Button";
import MobileHeader from "./MobileHeader";
import FooterHome from "./FooterHome";
import WalletConnectButton from "./Wallet/WalletConnectButton";

const Header = ({ children, isHome }) => {
  const { palette, ...theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: isMobile ? "block" : "flex",
        flexDirection: "column",
        width: "100vw",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isMobile ? (
        <MobileHeader isHome={isHome} />
      ) : (
        <Box
          sx={{
            // flexGrow: 1,
            "& .MuiPaper-root": {
              boxShadow: "none",
              backgroundColor: "transparent",
              [theme.breakpoints.down("sm")]: {
                top: "8px",
              },
            },
            "& .MuiToolbar-root": {
              justifyContent: "center",
            },
          }}
        >
          <AppBar>
            <Toolbar variant="dense">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "20px",
                  width: "97%",
                  "& button": { color: palette.grey[200] },
                  [theme.breakpoints.down("sm")]: {
                    width: "100%",
                  },
                }}
              >
                <Box
                  onClick={() => {
                    navigate("/");
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "200px",
                  }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "auto",
                      justifyContent: "center",
                      cursor: "var(--pointer-cursor)",
                    }}
                    src={Logo}
                    alt="Logo"
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center", // Center the content horizontally
                    alignItems: "center", // Center the content vertically
                    gap: "16px",
                    [theme.breakpoints.down("sm")]: {
                      width: "70%",
                      justifyContent: "flex-end",
                    },
                  }}
                >
                  {!isMobile && <WalletConnectButton height={"40px"} />}

                  <Box
                    onClick={() => {
                      window.open("https://yuga.com/", "_blank");
                    }}
                    sx={{
                      backgroundImage: `url('${STORAGE_URL}bayc-3d/Bayc.png')`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      cursor: "var(--pointer-default)",
                      width: "50px",
                      height: "46px",
                      mx: 1,
                    }}
                  ></Box>
                </Box>
              </Box>
            </Toolbar>
          </AppBar>
        </Box>
      )}
      <Box>{children}</Box>
      {!isMobile && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            overflow: "clip",
            width: "100vw",
            zIndex: 10000,
          }}
        >
          <FooterHome />
        </Box>
      )}
    </Box>
  );
};

export default Header;
